import { useLazyQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useCallback } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

type GetWorkflowTemplateFunction = (
  id: string,
) => Promise<API.WorkflowTemplateFragment | null | undefined>;

export function useGetWorkflowTemplateLazyQuery(): GetWorkflowTemplateFunction {
  const [getWorkflowTemplate] = useLazyQuery<
    API.GetWorkflowTemplateWithCardDefinitionQuery,
    API.GetWorkflowTemplateWithCardDefinitionQueryVariables
  >(Queries.workflow.getWorkflowTemplateWithCardDefinition);
  return useCallback<GetWorkflowTemplateFunction>(
    async (id: string) => {
      if (!isNil(id)) {
        const variables = { id };
        const result = await getWorkflowTemplate({ variables });
        return result.data?.getWorkflowTemplate as API.WorkflowTemplateFragment | null | undefined;
      }
    },
    [getWorkflowTemplate],
  );
}
